import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { labels } from "../../../../localization/labels";
import UserMaster from "./UserMaster";

const UsersAdministration = props => {
  return (
    <div className="container">
      <Tabs
        id="users_admin_id"
        className="tabVerticalSize"
        mountOnEnter
        unmountOnExit
      >
        <Tab eventKey="applicationUsers" title={labels.applicationUsers}>
          <UserMaster
            partyType={"applications"}
            messageHandler={props.messageHandler}
            breadcrumbsHandler={props.breadcrumbsHandler}
            history={props.history}
            tableLabel={labels.applicationUsers}
            showTableHeader
          />
        </Tab>
        <Tab eventKey="externalUsers" title={labels.externalUsers}>
          <UserMaster
            partyType={"externals"}
            messageHandler={props.messageHandler}
            breadcrumbsHandler={props.breadcrumbsHandler}
            history={props.history}
            tableLabel={labels.externalUsers}
            showTableHeader
          />
        </Tab>
      </Tabs>
    </div>
  );
};

export default UsersAdministration;
